import { SLOW_REQUEST_CONFIG } from './loadingUtil';

import axios from 'axios';
import { AMBIENTE_DESCARTADO, AMBIENTE_INICIADO } from '../actions/types';
import { removerAmbiente, salvarAmbiente } from './applicationContext';

const URL = process.env.NODE_ENV === 'production'
    ? 'https://vexado-admin-api.vexado.com.br'
    : 'http://localhost:8384';

const VERSION = 'master';
export { URL, VERSION }

export const ambienteUrl = `${URL}/ambiente`;

export const recuperarAmbiente = callback => dispatch => axios.get(ambienteUrl, SLOW_REQUEST_CONFIG)
  .then((response) => {
    const ambiente = response.data.ambiente;
    salvarAmbiente(ambiente);
    if (callback) {
      callback();
    }
    return dispatch({
      type: AMBIENTE_INICIADO,
      payload: ambiente
    });
  });

export const descartarAmbiente = () => {
  removerAmbiente();
  return {
    type: AMBIENTE_DESCARTADO
  };
};
